import { render, staticRenderFns } from "./SchoolEdit.vue?vue&type=template&id=10392d4a&scoped=true&"
import script from "./SchoolEdit.vue?vue&type=script&lang=ts&"
export * from "./SchoolEdit.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolEdit.vue?vue&type=style&index=0&id=10392d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10392d4a",
  null
  
)

export default component.exports